export default "__VITE_PUBLIC_ASSET__64045c69__"